var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.items
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0 20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "size": "small",
      "placeholder": "搜索"
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), _c('Page', {
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45fe4610","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ShiyongjigouTable.vue
// module id = nKEs
// module chunks = 142